import { axiosPost } from '../../axios/axios.js'
import { getRequestStateName } from '../../components/helpers.js'
import { getObjectAdditionalInfo } from './RequestGetObjectAdditionalInfo.js'
import { requestActionsAskAdjacentRequests } from './RequestActionsAskAdjacentRequests.js'
import { processYandexExecutorSelectionError } from '../../forms/YandexAccount/YandexAccountActions.js'
import AdditionalDepartureRequiredCard from '../Task/AdditionalDepartureRequiredCard.vue'

export const requestActions = {
  mixins: [getObjectAdditionalInfo, requestActionsAskAdjacentRequests],
  computed: {
    isContractorDispatcher: function () {
      const user = this.$store.getters.getUser
      return !user.roles.root && user.hasRole('contractorDispatcher') // user.roles.contractorDispatcher
    }
  },
  methods: {
    checkBPMove: async function () {
      const bpMoveInfo = {
        confirmed: true,
        props: null
      }
      if (this.request.bpStateId == 'BS8') {
        await new Promise(resolve => {
          const dialog = this.$d.dialog(this)
          dialog.show({
            maximized: false,
            persistent: true,
            headerLabel: getRequestStateName('BS10', this.request), // 'Требуется дополнительный выезд'
            contentComponent: AdditionalDepartureRequiredCard,
            contentProps: {
              request: this.request,
              requestRoles: this.requestRoles,
              callback: (data, confirmed) => {
                bpMoveInfo.confirmed = !!confirmed
                if (bpMoveInfo.confirmed) {
                  bpMoveInfo.props = data
                }
                // dialog.hide()
                this.$nextTick(() => {
                  resolve()
                })
                return Promise.resolve()
              }
            }
          })
        })
      }
      return bpMoveInfo
    },
    assignTaskToExecutorWithBPMove: function (taskId, bpMoveProps, callback) {
      const bpStateId = this.request.bpStateId
      const nextBPStateId = bpStateId == 'BS1' ? 'BS2' : bpStateId == 'BS8' ? 'BS10' : null
      if (nextBPStateId) {
        const bodyFormData = new FormData()
        bodyFormData.set('objectId', this.request.bpContextId)
        if (bpMoveProps != null) {
          bodyFormData.set('props', JSON.stringify(bpMoveProps))
        }

        axiosPost({
          url: '/service/delta/requestBusinessProcess/' + nextBPStateId,
          data: bodyFormData,
          onSuccess: (response) => {
            this.assignTaskToExecutor(taskId, callback)
          },
          onFailure: (response) => {
            this.$q.notify({
              type: 'negative',
              message: response.message,
              progress: true,
              timeout: 8000
            })
            !!callback && callback(new Error(response.message), response)
          }
        })
      } else {
        this.assignTaskToExecutor(taskId, callback)
      }
    },
    assignTaskToExecutor: async function (requestId, callback, newRequestsIds) {
      if (this.request.proposedExecutorObject) {
        let service
        const bodyFormData = new FormData()

        if (this.request.bpStateId === 'BS4') {
          const warnings = ['Активный отчёт об исполнении работ будет удален']

          if (!(await this.$d_askConfirmation('Продолжить назначение?', warnings))) {
            callback()
            return false
          }

          bodyFormData.set('reportDeletionConfirmed', true)
        }

        if (this.request.proposedExecutorObject.type === 'brigade') {
          const brigade = this.request.proposedExecutorObject.executor
          const brigadeId = brigade.brigadeId

          if (brigade.warnings && brigade.warnings.length) {
            if (!(await this.$d_askConfirmation('Продолжить назначение?', brigade.warnings))) {
              callback()
              return false
            }
          }

          const activeBrigadeOnServiceObject = await this.checkObjectHasActiveBrigade(requestId, brigadeId)
          if (activeBrigadeOnServiceObject !== '') {
            const continueAssignment = await new Promise((resolve, reject) => {
              this.$d_ask({
                callback: async (data, action) => {
                  if (action === 'yes') {
                    resolve(true)
                  } else if (action === 'no') {
                    resolve(false)
                  }
                },
                header: activeBrigadeOnServiceObject,
                buttons: {
                  yes: 'Назначить',
                  no: 'Отмена'
                }
              })
            })

            if (!continueAssignment) {
              callback()
              return
            }
          }

          if (this.request.hasAdjacentRequest) {
            if (!(await this.askAdjacentRequests('Назначить исполнителя'))) {
              callback()
              return false
            }
          }

          const currentRequestsIds = brigade.currentRequestsIds
          const customOrder = brigade.$_customOrder
          bodyFormData.set('ignoreEndWorkTime', true)

          if (customOrder) {
            service = '/brigade/saveQueue'
            bodyFormData.set('id', brigadeId)

            if (currentRequestsIds) {
              bodyFormData.set('currentRequests', currentRequestsIds.join(','))
            }

            const customRequestsIds = customOrder.requestsIds
            if (customOrder.targetRequestIndex) {
              customRequestsIds.splice(customOrder.targetRequestIndex, 0, this.request.requestId)
            }
            bodyFormData.set('requests', customRequestsIds.join(','))
          } else {
            service = '/request/addRequestToBrigade'
            bodyFormData.set('brigadeId', brigadeId)
            bodyFormData.set('requestId', requestId)
            if (brigade.workDateMillis) {
              bodyFormData.set('workDate', brigade.workDateMillis)
            }
            if (brigade.workShift) {
              bodyFormData.set('workShift', brigade.workShift)
            }
            bodyFormData.set('manual', true)

            if (this.requestInitial && this.requestInitial.autoAssign) {
              bodyFormData.set('ignoreAutoAssignment', true)
            }

            if (newRequestsIds) {
              bodyFormData.set('requestsId', newRequestsIds.join(','))
            } else if (currentRequestsIds) {
              bodyFormData.set('requestsId', currentRequestsIds.join(','))
            }
          }

          if (this.request.proposedReinforcementExecutorObject) {
            bodyFormData.set('reinforcementBrigades', this.request.proposedReinforcementExecutorObject.executors.map(executor => executor.brigadeId).join(','))
          } else if (this.request.riAssignedBrigades && this.request.riAssignedBrigades.length) {
            bodyFormData.set('reinforcementBrigades', this.request.riAssignedBrigades.map(br => br.id).join(','))
          }
        } else {
          service = '/request/assignemployee'
          bodyFormData.set('request', this.request.requestId)
          const executor = this.request.proposedExecutorObject
          bodyFormData.set('employee', executor.login || executor.executor.key)

          if (executor.type === 'self') {
            const user = this.$store.getters.getUser
            const acceptActionName = user.isContractor ? 'принять к исполнению' : 'начать работы'

            const action = await new Promise((resolve, reject) => {
              this.$d_ask({
                callback: (data, action) => {
                  resolve(action)
                },
                header: 'Вы будете назначены на заявку. Хотите сразу ' + acceptActionName + '?',
                buttons: {
                  yes: 'Назначить и ' + acceptActionName,
                  ok: 'Назначить',
                  cancel2: 'Отмена'
                }
              })
            })

            if (action === 'cancel2') {
              callback()
              return
            } else if (action === 'yes') {
              bodyFormData.set('accept', true)
            }
          }
        }

        const url = '/service/delta' + service
        this.executeAssignTaskToExecutorRequest(url, bodyFormData, callback)
      } else if (this.request.proposedReinforcementExecutorObject && this.request.proposedReinforcementExecutorObject.executors) {
        this.assignReinforcement(requestId, callback)
      }
    },
    executeAssignTaskToExecutorRequest: function (url, bodyFormData, callback) {
      return axiosPost({
        url: url,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: (response) => {
          this.$q.notify({
            type: 'positive',
            message: response.data.result || 'Успешное выполнение операции назначения исполнителя',
            progress: true,
            timeout: 3000
          })

          callback(null, {
            message: response.data.result,
            checkNewReport: true
          })
        },
        onFailure: (response) => {
          if (response.type === 'requests_queue_changed') {
            this.onAssignTaskToExecutorError(response, callback)
          } else if (response.type === 'yandex_employee_not_assigned_to_brigade') {
            this.onSelectYandexExecutorError(response, url, bodyFormData, callback)
          } else {
            this.$q.notify({
              type: 'negative',
              message: response.message,
              progress: true,
              timeout: 8000
            })
            callback(new Error(response.message))
          }
        }
      })
    },
    onAssignTaskToExecutorError: function (response, callback) {
      const newRequestsId = []
      const newRequestsName = []
      for (let i = 0; i < response.requestsId.length; i++) {
        newRequestsId.push(response.requestsId[i].id)
        newRequestsName.push(response.requestsId[i].name)
      }

      this.$d_ask({
        callback: (data) => {
          this.assignTaskToExecutor(this.request.requestId, callback, newRequestsId)
        },
        header: response.message + ' Всё равно назначить исполнителем?',
        propsConfig: {
          email: { type: 'text', label: 'Очередь бригады', value: newRequestsName.join(', '), readonly: true }
        }
      })
    },
    onSelectYandexExecutorError: function (response, url, bodyFormData, callback) {
      processYandexExecutorSelectionError(this, response)
        .then(accountAssignmentConfig => {
          bodyFormData.set('accountAssignedEmployee', accountAssignmentConfig.assignedEmployeeId)
          this.executeAssignTaskToExecutorRequest(url, bodyFormData, callback)
        })
    },
    assignReinforcement: function (requestId, callback) {
      const bodyFormData = new FormData()
      bodyFormData.set('id', requestId)
      bodyFormData.set('brigades', this.request.proposedReinforcementExecutorObject.executors.map(executor => executor.brigadeId).join(','))

      return axiosPost({
        url: '/service/delta/reinforcement/assignBrigades',
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: (response) => {
          const message = 'Назначено усиление'
          this.$q.notify({
            type: 'positive',
            message: message,
            progress: true,
            timeout: 3000
          })
          callback(null, {
            message: message,
            checkNewReport: false
          })
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
          callback(new Error(response.message))
        }
      })
    },
    isTaskValid: async function () {
      const fieldsToFill = []
      if (!this.isInitialize && !this.request.requestToAudit && !this.request.requestsToAudit && !this.request.objectsToAudit) {
        // Проверка, что адрес неисправности указан при создании и не удален при других состояниях
        if (!this.request.location && ((this.request.bpStateId == null || this.request.bpStateId === 'BS0') || (!!this.requestInitial && !!this.requestInitial.location))) {
          if (this.request.isFieldIncluded('location')) { // Проверяем, что координаты не исключены из списка полей заявки
            if (!(await this.$d_askConfirmation('Не указаны координаты неисправности. Продолжить?'))) {
              return false
            }
          }
        }

        if (!this.request.requestSource) {
          fieldsToFill.push('Источник заявки')
        }
      }
      if (!this.request.requestTypeObject) {
        fieldsToFill.push('Тип заявки')
      }
      if (!this.request.requestPriority) {
        fieldsToFill.push('Приоритет')
      }
      if (this.request._configuration.isFieldRequired('applicantDescription')) {
        const val = this.request.applicantDescription
        if (!val || !val.trim()) {
          fieldsToFill.push('Описание от заявителя')
        }
      }
      if (this.request._configuration.isFieldRequired('remontPositionName')) {
        const val = this.request.remontPositionName
        if (!val || !val.trim()) {
          fieldsToFill.push('Ремонтируемое оборудование')
        }
      }
      if (fieldsToFill.length) {
        this.$q.notify({
          type: 'negative',
          message: 'Для сохранения заявки нужно заполнить поля: "' + fieldsToFill.join('", "') + '".',
          progress: true,
          timeout: 8000
        })
        return false
      }
      return true
    }
  }
}
